import { ButtonWithLinkStyle, type ThemeColorType } from '@capsule/consumer-design-system';

import styled, { css } from 'styled-components';
import InlineSVG from 'svg-inline-react';

export const ButtonContent = styled.div`
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 1rem 0rem;
  width: 100%;
`;

export const LinkWithIcon = styled(ButtonWithLinkStyle)<{ color?: ThemeColorType }>`
  margin: 2rem 0;
  color: ${props => (props.color ? props.theme.colors[props.color] : props.theme.colors.capsuleBlue50)};
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const TextColumn = styled.div`
  margin-left: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  text-transform: none;
  text-wrap: wrap;
  letter-spacing: 0;
  width: 350px;
  ${({ theme }) => theme.mediaQueries.mediumDown} {
    width: 50vw;
  }
`;

export const StyledArrow = styled(InlineSVG)<{ color?: ThemeColorType }>`
  height: 1.75rem;
  width: 1.75rem;
  svg {
    line-height: 1.75rem;
    height: 1.75rem;
    width: 1.75rem;
    transform: rotate(-90deg);
    path {
      fill: ${props => (props.color ? props.theme.colors[props.color] : props.theme.colors.capsuleBlue50)};
    }
  }
`;

// SVGs
const mixBlendMultiply = css`
  mix-blend-mode: multiply;
`;

export const StethoscopeArt = () => (
  <svg
    width="64"
    height="64"
    viewBox="24 10 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={css`
      overflow: visible;
    `}
  >
    <circle cx="56" cy="43.0002" r="32" fill="#99BFBC" />
    <g css={mixBlendMultiply}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.0381 25.7049C57.22 25.7049 58.1814 24.7606 58.2089 23.5853C60.2364 23.2017 61.7646 23.4672 62.7935 24.3818C65.7383 26.9995 64.6258 34.4598 63.7097 40.4805C63.6752 40.8597 63.6225 41.2026 63.5709 41.5379C63.2536 41.6776 63.0338 41.984 62.99 42.3783C62.401 49.5114 60.9613 53.3071 58.6708 53.896C56.3804 54.485 53.2392 51.9982 49.1164 46.1085C48.8752 45.7708 48.4563 45.6109 48.0692 45.6812C47.8457 45.4155 47.6212 45.1403 47.4148 44.8651C43.6191 40.1533 38.9073 34.1981 40.1507 30.4679C40.5595 29.1248 41.802 28.0943 43.8318 27.423C44.2152 28.0383 44.8979 28.4478 45.6762 28.4478C46.8754 28.4478 47.8476 27.4756 47.8476 26.2763C47.8476 25.0771 46.8754 24.1049 45.6762 24.1049C44.4769 24.1049 43.5047 25.0771 43.5047 26.2763C43.5047 26.3363 43.5072 26.3956 43.5119 26.4543C41.1773 27.2188 39.6981 28.495 39.1691 30.1407C37.8095 34.3491 42.5991 40.4151 46.5036 45.3601L46.6295 45.5195C46.8716 45.7962 47.0954 46.0546 47.3106 46.3141C47.1842 46.6284 47.2079 46.9967 47.4149 47.2864C49.9974 50.9594 53.1839 54.9343 56.5329 55.8568L59.0034 58.7953C59.5547 59.9726 60.2568 60.812 61.0013 61.482C57.5329 62.2673 54.5225 64.0342 52.4938 66.521C50.0071 69.6622 49.2218 73.9159 50.5306 77.3843C51.8394 80.9182 55.3078 83.3395 58.8417 83.3395H59.8233C62.3755 83.0123 64.8623 81.3763 66.5638 78.8895C69.7705 74.1777 69.5087 67.6335 66.0403 63.1835C68.0035 63.3144 70.1631 63.707 72.3881 64.3614C73.7624 64.7541 75.1367 65.2776 76.4455 65.8012C76.9097 65.9618 77.3787 66.1322 77.8526 66.3044C79.1159 66.7634 80.4138 67.235 81.7463 67.5681C81.8839 67.6025 82.0232 67.6375 82.164 67.673C84.8374 68.3455 88.056 69.1552 90.9906 68.4059C91.7671 69.4337 92.9994 70.098 94.3868 70.098C96.7361 70.098 98.6405 68.1935 98.6405 65.8443C98.6405 63.495 96.7361 61.5906 94.3868 61.5906C92.0376 61.5906 90.1331 63.495 90.1331 65.8443C90.1331 66.051 90.1479 66.2542 90.1763 66.4531C87.6607 66.975 84.727 66.2095 82.2698 65.5394C80.5684 65.0813 78.8669 64.4269 77.1654 63.7725L77.1652 63.7724C75.791 63.2489 74.4168 62.7254 72.9771 62.2673C69.705 61.2857 66.6293 60.8276 63.8153 61.0239L63.7498 60.9585L63.5919 60.8403C62.6606 60.1441 61.7209 59.4416 61.0307 58.2174L61.4446 54.5762C62.2766 53.7354 62.9663 52.5489 63.5135 51.0166C64.2334 48.9224 64.6915 46.2393 65.0187 42.5746C65.0623 42.1824 64.9027 41.8483 64.6174 41.6494L64.6258 41.5931L64.6258 41.593C64.6749 41.2658 64.724 40.9386 64.7567 40.6113C65.7383 34.3944 66.8509 26.6068 63.5133 23.5965C62.1833 22.4978 60.3424 22.1145 57.9904 22.5819C57.6377 21.8596 56.896 21.3621 56.0381 21.3621C54.8388 21.3621 53.8666 22.3342 53.8666 23.5335C53.8666 24.7327 54.8388 25.7049 56.0381 25.7049ZM62.8992 63.2162L62.8991 63.2162L62.899 63.2162C62.7681 63.2326 62.6373 63.2489 62.5064 63.2489C59.038 63.7724 56.0277 65.4085 54.1299 67.7644C52.0358 70.3166 51.3813 73.8505 52.4938 76.6645C53.6064 79.6094 56.7476 81.5726 59.627 81.2454C61.6557 80.9836 63.5535 79.6748 64.9278 77.6461C67.7418 73.5887 67.3491 67.5681 64.0116 63.9033C63.8826 63.7314 63.7254 63.5877 63.5586 63.4351L63.5585 63.4351C63.4713 63.3554 63.3815 63.2733 63.2917 63.1835C63.1609 63.1835 63.03 63.1998 62.8992 63.2162Z"
        fill="#DFECEA"
      />
    </g>
    <path
      d="M54.791 54.0737L57.5235 57.324L58.3249 57.0186L59.5045 56.7145L59.9609 52.6995L54.791 54.0737Z"
      fill="#EF4931"
    />
    <path
      d="M46.3489 45.5012C45.9563 44.9776 45.5636 44.5195 45.1055 43.996C41.179 39.0224 36.2709 32.8709 37.6452 28.6172C38.2342 26.7848 40.0011 25.4105 42.8151 24.6907L43.0768 25.6723C40.5901 26.3267 39.0849 27.4392 38.6268 28.9444C37.3834 32.6746 42.0952 38.6298 45.8908 43.3416C46.2835 43.8651 46.7416 44.3886 47.1342 44.8467L46.3489 45.5012Z"
      fill="white"
    />
    <path
      d="M62.9711 41.051L61.924 40.9201C61.9895 40.2657 62.1204 39.6767 62.1858 38.9569C63.102 32.9362 64.2145 25.4759 61.2696 22.8582C60.0917 21.8111 58.2593 21.6148 55.7725 22.2692L55.5107 21.2876C58.3247 20.5023 60.4843 20.8295 61.9895 22.0729C65.327 25.0832 64.2145 32.8708 63.2329 39.0878C63.1674 39.7422 63.0365 40.3966 62.9711 41.051Z"
      fill="white"
    />
    <circle cx="44.1524" cy="24.7527" r="2.17143" fill="#0F3C6C" />
    <circle cx="54.5142" cy="22.0098" r="2.17143" fill="#0F3C6C" />
    <path
      d="M56.4274 54.532C52.5663 54.532 48.8361 49.9511 45.8912 45.7628C45.564 45.3047 45.6949 44.6503 46.153 44.3231C46.6111 43.9959 47.2655 44.1268 47.5927 44.5849C51.7156 50.4746 54.8568 52.9614 57.1472 52.3724C59.4377 51.7835 60.8774 47.9878 61.4664 40.8547C61.5318 40.2657 61.9899 39.8731 62.5789 39.9385C63.1679 40.0039 63.5605 40.462 63.4951 41.051C63.1679 44.7158 62.7098 47.3989 61.9899 49.493C61.0083 52.2415 59.5686 53.8776 57.6707 54.4011C57.2127 54.4666 56.82 54.532 56.4274 54.532Z"
      fill="#EF4931"
    />
    <path
      d="M57.318 81.816C53.7842 81.816 50.3158 79.3946 49.0069 75.8608C47.6981 72.3923 48.4834 68.1386 50.9702 64.9974C52.9989 62.5106 56.0092 60.7437 59.4776 59.9584C58.1688 58.7805 56.9908 57.079 56.5327 53.9378C56.4673 53.3488 56.8599 52.8253 57.3835 52.7598C57.9724 52.6944 58.496 53.087 58.5614 53.6106C59.0195 57.1444 60.6555 58.2569 62.2261 59.4349L62.2916 59.5003C65.1056 59.304 68.1813 59.7621 71.4534 60.7437C72.8931 61.2018 74.2674 61.7253 75.6417 62.2489C77.3432 62.9033 79.0447 63.5577 80.7462 64.0158C83.6256 64.8011 87.1595 65.7173 89.908 64.5393C90.4315 64.343 91.0205 64.5393 91.2823 65.0629C91.4786 65.5864 91.2823 66.1754 90.7587 66.4371C87.3558 67.9423 83.3638 66.8298 80.2226 66.0445C78.3902 65.5864 76.6233 64.8665 74.9219 64.2776C73.613 63.754 72.2387 63.2305 70.8645 62.8378C68.6394 62.1834 66.4799 61.7908 64.5166 61.6599C67.985 66.1099 68.2468 72.6541 65.0401 77.3659C63.3387 79.8527 60.8519 81.4887 58.2996 81.816C58.0379 81.816 57.7107 81.816 57.318 81.816ZM61.7681 61.6599C61.5063 61.6599 61.2445 61.7253 60.9827 61.7253C57.5143 62.2489 54.504 63.8849 52.6062 66.2408C50.5121 68.7931 49.8577 72.3269 50.9702 75.1409C52.0827 78.0858 55.2239 80.049 58.1033 79.7218C60.132 79.4601 62.0298 78.1512 63.4041 76.1225C66.2181 72.0651 65.8254 66.0445 62.4879 62.3798C62.2916 62.118 62.0298 61.9217 61.7681 61.6599Z"
      fill="#EF4931"
    />
    <path
      d="M92.8631 68.5743C95.2123 68.5743 97.1168 66.6699 97.1168 64.3206C97.1168 61.9713 95.2123 60.0669 92.8631 60.0669C90.5138 60.0669 88.6094 61.9713 88.6094 64.3206C88.6094 66.6699 90.5138 68.5743 92.8631 68.5743Z"
      fill="#0F3C6C"
    />
  </svg>
);

export const PillBottleArt = () => (
  <svg
    width="64"
    height="64"
    viewBox="24 11 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={css`
      overflow: visible;
    `}
  >
    <circle cx="56" cy="43.0002" r="32  " fill="#99BFBC" />
    <g css={mixBlendMultiply}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.7324 19.6562C40.232 19.7242 39.8815 20.1849 39.9495 20.6852L41.5863 32.7336C41.6542 33.2339 42.1149 33.5844 42.6153 33.5165L45.6348 33.1062C45.4705 33.6827 45.1223 34.2013 44.6272 34.574L43.8628 35.1492C42.7712 35.9707 42.2089 37.3183 42.3928 38.6721L46.2906 67.3641C46.6305 69.8658 48.9341 71.6184 51.4359 71.2785L69.5423 68.8187C72.0441 68.4788 73.7966 66.1752 73.4568 63.6735L69.5589 34.9815C69.375 33.6277 68.4736 32.479 67.2023 31.9785L66.3122 31.628C65.7356 31.401 65.2617 30.994 64.9496 30.4823L67.9695 30.072C68.4698 30.0041 68.8203 29.5433 68.7524 29.043L67.1156 16.9947C67.0476 16.4943 66.5869 16.1438 66.0865 16.2118L40.7324 19.6562Z"
        fill="#DFECEA"
      />
    </g>
    <path
      d="M40.7978 37.2999C40.6139 35.946 41.1762 34.5985 42.2679 33.777L43.0322 33.2018C43.841 32.5931 44.2576 31.5948 44.1213 30.5917V30.5917C43.9135 29.0618 44.9852 27.6531 46.5151 27.4453L59.8248 25.6371C61.3547 25.4293 62.7634 26.501 62.9713 28.0309V28.0309C63.1075 29.034 63.7754 29.885 64.7172 30.2558L65.6073 30.6063C66.8786 31.1068 67.78 32.2555 67.9639 33.6093L71.8593 62.2832C72.2005 64.7949 70.441 67.1077 67.9292 67.4489L49.859 69.9038C47.3472 70.2451 45.0344 68.4855 44.6932 65.9737L40.7978 37.2999Z"
      fill="#0F3C6C"
    />
    <path
      d="M41.2056 40.3054L42.0666 40.1885C43.7344 39.9619 45.2701 41.1302 45.4967 42.7981L47.8395 60.0436C48.0661 61.7114 46.8977 63.2471 45.2299 63.4737L44.3689 63.5907L41.2056 40.3054Z"
      fill="#F8FBFB"
    />
    <path
      d="M48.8238 42.346C48.5973 40.6782 49.7656 39.1425 51.4335 38.9159L68.3723 36.6147L71.5357 59.9L54.5968 62.2012C52.929 62.4277 51.3932 61.2594 51.1667 59.5915L48.8238 42.346Z"
      fill="#F8FBFB"
    />
    <rect
      x="51.8257"
      y="43.6626"
      width="15.1164"
      height="1.95826"
      rx="0.97913"
      transform="rotate(-7.73638 51.8257 43.6626)"
      fill="#D9D9D9"
    />
    <rect
      x="52.2773"
      y="46.9893"
      width="17.3446"
      height="6.43428"
      transform="rotate(-7.73638 52.2773 46.9893)"
      fill="#DFECEA"
    />
    <rect
      x="42.2979"
      y="48.345"
      width="1.95826"
      height="6.43428"
      transform="rotate(-7.73638 42.2979 48.345)"
      fill="#DFECEA"
    />
    <path
      d="M57.6038 57.4837C57.9267 57.4381 58.1515 57.1393 58.1059 56.8164V56.8164C58.0603 56.4935 57.7616 56.2686 57.4387 56.3142L56.4363 56.4557L55.4319 57.7903L57.6038 57.4837Z"
      fill="#74A6A2"
    />
    <path
      d="M54.2644 56.7624C53.9415 56.808 53.7166 57.1068 53.7622 57.4297V57.4297C53.8078 57.7526 54.1066 57.9775 54.4295 57.9319L55.4319 57.7904L56.4362 56.4558L54.2644 56.7624Z"
      fill="#FFD300"
    />
    <path
      d="M56.7426 58.6277C56.7882 58.9506 56.5634 59.2494 56.2405 59.295V59.295C55.9175 59.3405 55.6188 59.1157 55.5732 58.7928L55.4317 57.7904L56.436 56.4558L56.7426 58.6277Z"
      fill="#0F3C6C"
    />
    <path
      d="M55.125 55.6184C55.0794 55.2955 55.3043 54.9967 55.6272 54.9511V54.9511C55.9501 54.9056 56.2489 55.1304 56.2945 55.4533L56.436 56.4557L55.4316 57.7902L55.125 55.6184Z"
      fill="#EF4931"
    />
    <path
      d="M38.355 19.3127C38.287 18.8124 38.6375 18.3516 39.1379 18.2837L64.4921 14.8392C64.9924 14.7713 65.4531 15.1218 65.5211 15.6221L67.1579 27.6705C67.2259 28.1708 66.8754 28.6315 66.375 28.6995L41.0208 32.1439C40.5205 32.2119 40.0598 31.8614 39.9918 31.361L38.355 19.3127Z"
      fill="#F8FBFB"
    />
    <g css={mixBlendMultiply}>
      <path
        d="M35.8478 32.1983L27.2966 29.4626C26.7215 29.2779 26.1026 29.5664 25.8744 30.1258L22.4712 38.4359C22.269 38.929 22.4303 39.5005 22.8647 39.8164L33.8688 47.8124C34.2093 48.061 34.658 48.1025 35.0386 47.925C35.4193 47.7475 35.6736 47.3782 35.7044 46.9565L36.6547 33.3861C36.6919 32.8502 36.3589 32.3616 35.8501 32.1972"
        fill="#DFECEA"
      />
    </g>
    <path
      d="M34.3244 30.6744L25.7732 27.9387C25.198 27.7539 24.5792 28.0425 24.351 28.6019L20.9478 36.912C20.7456 37.4051 20.9068 37.9766 21.3413 38.2925L32.3454 46.2885C32.6859 46.5371 33.1345 46.5785 33.5152 46.401C33.8959 46.2235 34.1501 45.8543 34.1809 45.4325L35.1312 31.8621C35.1685 31.3263 34.8355 30.8377 34.3267 30.6733"
      fill="#FFD300"
    />
    <g css={mixBlendMultiply}>
      <path
        d="M89.0717 37.6496C91.5194 39.2392 90.9809 44.4114 87.8688 49.2036C84.7567 53.9959 80.2507 56.5915 77.8029 55.0019C75.3552 53.4123 75.8937 48.2401 79.0058 43.4479C82.1179 38.6557 86.6239 36.06 89.0717 37.6496"
        fill="#DFECEA"
      />
    </g>
    <path
      d="M87.8524 35.821C90.3002 37.4106 89.7617 42.5828 86.6496 47.375C83.5375 52.1672 79.0314 54.7629 76.5837 53.1733C74.1359 51.5837 74.6744 46.4115 77.7865 41.6193C80.8986 36.8271 85.4047 34.2314 87.8524 35.821"
      fill="#EF4931"
    />
  </svg>
);
